import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import {addPendingSubmission} from "../../../store/coreSlice";

const SubmitPending = (props) => {
	const handleVerify = () => {
		props.addPendingSubmission(props.latitude, props.longitude, props.keyName);
		props.onClose();
	};

	return (<Dialog open={true}>
			<DialogTitle id="alert-dialog-title">Adding PokéStop Submission</DialogTitle>
			<DialogContent>
				Did you submit a PokéStop nomination in this cell? This will add it to the map to help prevent
				duplicates. You can also <a href='/mod/pokemon/map/import-wayfarer.php'>bulk import</a> your
				submissions directly from Wayfarer.
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose}>
					Cancel
				</Button>
				<Button onClick={handleVerify} color="primary">
					Add Submission
				</Button>
			</DialogActions>
		</Dialog>);
};

SubmitPending.propTypes = {
	onClose: PropTypes.func.isRequired,
	latitude: PropTypes.number.isRequired,
	longitude: PropTypes.number.isRequired,
	keyName: PropTypes.string.isRequired
};

const mapDispatchToProps = (dispatch) => {
	return {
		addPendingSubmission: (latitude, longitude, key) => dispatch(addPendingSubmission(latitude, longitude, key)),
	};
};

export default connect(null, mapDispatchToProps)(SubmitPending);